import * as React from "react";
import { Search } from "lucide-react";
import { Select } from "@/components/ui/select";
import { cn } from "@/lib/utils";

export function FilterBar({
  className,
  variant = "boxed",
  children,
}: {
  className?: string;
  variant?: "boxed" | "flat";
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        "mb-4 flex flex-wrap items-center gap-2",
        variant === "boxed" && "rounded-lg border border-line bg-surface px-3.5 py-2.5",
        className
      )}
    >
      {children}
    </div>
  );
}

export function FilterSearch({
  value,
  onChange,
  placeholder,
  className,
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
}) {
  return (
    <div className={cn("relative flex-1 min-w-[200px] max-w-[300px]", className)}>
      <Search aria-hidden className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full py-[7px] pl-9 pr-2 text-sm text-ink outline-none placeholder:text-subtle"
      />
    </div>
  );
}

export function FilterSelect({
  value,
  onChange,
  options,
  ariaLabel,
}: {
  value: string;
  onChange: (v: string) => void;
  options: { value: string; label: string }[];
  ariaLabel?: string;
}) {
  return (
    <Select value={value} onChange={(e) => onChange(e.target.value)} aria-label={ariaLabel}>
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </Select>
  );
}